/* eslint-disable */
import React from 'react';
import { ThemeProvider } from 'styled-components';

import GlobalStyles from './global'
import { themeCommon } from './common';


export const theme = {
  ...themeCommon({
    // add styles to override theme
  })
}

export const ThemeWrapper = ({ children }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    {children}
  </ThemeProvider>
)